import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChatCircleDots } from "@phosphor-icons/react";
import client from "../lib/api";
import { coverImage, onPropImgError } from "../lib/helpers";

export default function MessagesPanel({ onOpen }) {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchThreads = () => client.get("/messages/threads").then((r) => { setThreads(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => {
    fetchThreads();
    const iv = setInterval(fetchThreads, 4000);
    return () => clearInterval(iv);
  }, []);

  if (loading) return <p className="text-[#5C5A58]">Loading conversations…</p>;
  if (threads.length === 0) return (
    <div className="text-center py-24 text-[#5C5A58]" data-testid="messages-empty">
      <ChatCircleDots size={48} weight="duotone" className="mx-auto mb-4 text-[#4A0000]" />
      <p>No conversations yet.</p>
    </div>
  );

  return (
    <div className="max-w-3xl space-y-3" data-testid="messages-panel">
      {threads.map((t, i) => (
        <motion.button key={t.property_id} data-testid={`thread-${t.property_id}`}
          initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }}
          onClick={() => onOpen(t.property_id)}
          className={`w-full text-left flex items-center gap-4 bg-white border rounded-md p-4 hover:-translate-y-0.5 transition-transform ${t.unread > 0 ? "border-[#B08D57]" : "border-[#E9DDC6]"}`}>
          <div className="w-14 h-14 rounded-md bg-[#FAF9F6] overflow-hidden flex-shrink-0">
            <img src={coverImage({ image: t.image, package_type: t.package_type, id: t.property_id, title: t.title })}
              alt="" onError={onPropImgError} className="w-full h-full object-cover object-top" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2">
              <h3 className={`truncate ${t.unread > 0 ? "font-bold text-[#4A0000]" : "font-semibold"}`}>{t.title}</h3>
              {t.unread > 0 && (
                <span data-testid={`thread-badge-${t.property_id}`}
                  className="min-w-5 h-5 px-1.5 rounded-full bg-[#B08D57] text-[#4A0000] text-xs font-bold flex items-center justify-center flex-shrink-0">
                  {t.unread}
                </span>
              )}
            </div>
            <p className="text-sm text-[#5C5A58] truncate">
              {t.last_message
                ? <><span className="font-medium">{t.last_sender_name}:</span> {t.last_message}</>
                : <span className="italic">No messages yet — start the conversation</span>}
            </p>
          </div>
        </motion.button>
      ))}
    </div>
  );
}
